import React, { useState, useEffect } from 'react';

const Geolocs = () => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSolicitudes = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        Usr: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        DatosMetodo: {
          NombreMetodo: 'ControlGeocercas',
          Datos_Recibidos: '{"Accion":"SEL"}'
        }
      };
      console.log(requestData)
      const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(requestData))}`;
      const response = await fetch(url);
      console.log(response)
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.datos_Generados) {
        throw new Error('No se encontraron datos generados');
      }
      
      console.log(data)
      const datosGenerados = JSON.parse(data.datos_Generados);
      setSolicitudes(datosGenerados.GEOCERCAS || []);
      
    } catch (err) {
      setError(err.message);
      console.error('Error al obtener solicitudes:', err);
    } finally {
      setLoading(false);
    }
  };

  // Opcional: cargar automáticamente al montar el componente
  useEffect(() => {
    fetchSolicitudes();
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Prueba de Solicitudes</h1>
      
      <button 
        onClick={fetchSolicitudes} 
        disabled={loading}
        style={{
          padding: '10px 15px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          marginBottom: '20px'
        }}
      >
        {loading ? 'Cargando...' : 'Obtener Solicitudes'}
      </button>
      
      {error && (
        <div style={{ 
          color: 'red', 
          padding: '10px', 
          border: '1px solid red',
          borderRadius: '4px',
          marginBottom: '20px'
        }}>
          Error: {error}
        </div>
      )}
      
      <h2>Resultados:</h2>
      
      {loading ? (
        <p>Cargando datos...</p>
      ) : (
        <div>
          {solicitudes.length > 0 ? (
            <div>
              <p>Total de solicitudes: {solicitudes.length}</p>
              <pre style={{
                backgroundColor: '#f5f5f5',
                padding: '15px',
                borderRadius: '4px',
                overflowX: 'auto'
              }}>
                {JSON.stringify(solicitudes, null, 2)}
              </pre>
            </div>
          ) : (
            <p>No hay solicitudes para mostrar</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Geolocs;